function ArticleItems(resultContainer, ajaxUrls, options, filterOptions) {
	this.resultContainer = this.getResultContainer(resultContainer);
	this.resultWrapperContainer = this.resultContainer.parentNode;
	this.ajaxUrls = ajaxUrls;
	this.filterOptions = filterOptions;

	//default options
	this.options = {
		'classPrefixItem' : 'item',
		'loadOneTime' : 'all',
		'strings' : {
			'noResults' : 'No results'
		}
	};

	//quick fix var
	this.overwriteLoadCount = false;

	//voeg input opties samen met default opties
	for (var attrname in options) { this.options[attrname] = options[attrname]; }

	//validate required inputs
	if (!this.resultContainer || this.resultContainer.nodeType != 1) {
		this.onError('Something went wrong with the construction of the page.');
		return;
	}

	if(!this.ajaxUrls || typeof this.ajaxUrls.items != 'string'){
		this.onError('Cannot make ajax request, url not available or not wel formed.');
		return;
	}

	// binds
	this.loadItems = this.loadItems.bind(this);
	this.addItems = this.addItems.bind(this);
	this.parseItems = this.parseItems.bind(this);

	this.parseItemsRequest = new XMLHttpRequest();
	this.parseItemsRequest.addEventListener('readystatechange', this.parseItems);
}

ArticleItems.prototype.getResultContainer = function(containerElement) {
	if (containerElement.nodeName != 'UL') {
		containerElement = containerElement.querySelector('> ul');
	}

	return containerElement;
};

ArticleItems.prototype.setItemsLoading = function() {
	this.resultWrapperContainer.classList.add('is-loading');
};

ArticleItems.prototype.removeItemsLoading = function() {
	this.resultWrapperContainer.classList.remove('is-loading');
};

ArticleItems.prototype.setItemLoadingStatus = function(item) {
	if (!item.images) {
		this.initLoadingItemImages(item);
	}

	if (!item.images) {
		return;
	}

	if (this.isAllImagesLoaded(item)){
		item.node.classList.remove('is-loading');
	}
	else {
		item.node.classList.add('is-loading');
	}
};

ArticleItems.prototype.initLoadingItemImages = function(item) {
	item.images = item.node.getElementsByTagName('img');

	if (!item.images) {
		return;
	}

	item.images = [].slice.call(item.images);

	item.images = item.images.map(image => {
		return {
			element: image,
			loaded: false
		}
	});

	item.images.forEach(image => {
		image.element.addEventListener('load', function(event) {
			this.onItemImageLoaded(item, image);
		}.bind(this));
	});
};

ArticleItems.prototype.onItemImageLoaded = function(item, image) {
	item.images.forEach(itemImage => {
		if(itemImage == image) {
			itemImage.loaded = true;
		}
	});

	this.setItemLoadingStatus(item);
};

ArticleItems.prototype.isAllImagesLoaded = function(item) {
	let allLoaded = true;
	item.images.forEach(image => {
		if (!image.loaded) {
			allLoaded = false;
		}
	});

	return allLoaded;
};

ArticleItems.prototype.loadItems = function(options) {
	this.parseItemsRequest.abort();

	this.setItemsLoading();

	let url = this.ajaxUrls.items;

	if (!options) {
		options = {};
		if (this.options.types) { options.types = this.options.types; }
		if (this.options.categories) { options.categories = this.options.categories; }
	}

	if (options.types) {
		url += '&types=' + (Array.isArray(options.types) ? options.types.join(',') : options.types);
	}

	if (options.categories) {
		url += '&categories=' + (Array.isArray(options.categories) ? options.categories.join(',') : options.categories);
	}

	this.parseItemsRequest.open('GET', url);
	this.parseItemsRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

	this.parseItemsRequest.send();
};

ArticleItems.prototype.parseItems = function() {
	if(this.parseItemsRequest.readyState != 4) return;
	if(this.parseItemsRequest.status != 200 && this.parseItemsRequest.status != 304) {
		console.log('HTTP error ' + this.parseItemsRequest.status);
		return;
	}

	if(!this.parseItemsRequest.responseText){
		this.onError('Cannot load item data');
	}

	this.removeItemsLoading();

	this.itemData = JSON.parse(this.parseItemsRequest.responseText);

	this.addItems(true);
};

ArticleItems.prototype.addItems = function(reset) {
	if(typeof reset != 'boolean' || !reset){
		reset = false;
	}

	if(reset === true){
		this.resetContainer();
	}

	let currentlyLoaded = 0;

	for(let i=0;i<this.itemData.length;i++){
		if(this.itemData[i].displayed){
			continue;
		}

		if(this.filterData){
			let itemsValidated = this.checkFilter(this.itemData[i]);
			if(itemsValidated == 0){
				continue;
			}
		}

		this.itemData[i].node = this.createElementFromString(this.itemData[i].html);
		this.resultContainer.appendChild(this.itemData[i].node);
		// To do: hack, is-loading class needs a delay
		//setTimeout( function() {
			this.setItemLoadingStatus(this.itemData[i]);
		//}.bind(this), 1);



		this.itemData[i].displayed = true;
		currentlyLoaded ++;

		if(this.options.loadOneTime != 'all' && currentlyLoaded >= this.options.loadOneTime){
			break;
		}
	}

	//checken of alles nu ingeladen is, zo ja de button verwijderen
	const totalItemsAvailable = this.itemData.length;
	if(this.loadMoreButton){
		var totalItemsLoaded = 0;
		for(var i=0;i<this.itemData.length;i++){
			if(this.itemData[i].displayed){
				totalItemsLoaded ++;
			}
		}

		if(totalItemsLoaded >= totalItemsAvailable){
			this.loadMoreButton.parentNode.removeChild(this.loadMoreButton);
			this.loadMoreButton = null;
		}
	}

	if(totalItemsAvailable < 1){
		this.onNoResults();
	}
};

ArticleItems.prototype.resetContainer = function() {
	while(this.resultContainer.firstChild){
		this.resultContainer.removeChild(this.resultContainer.firstChild);
	}

	//displayed on false
	for(var i=0;i<this.itemData.length;i++){
		this.itemData[i].displayed = false;
	}

	if(this.options.loadOneTime != 'all' && !this.loadMoreButton){
		this.loadMoreButton = this.createLoadMoreButton();

		this.resultContainer.parentNode.appendChild(this.loadMoreButton);
	}
};

ArticleItems.prototype.createLoadMoreButton = function(){
	var buttonElement = document.createElement('button');

	buttonElement.setAttribute('class', this.options.classPrefixItem + '-load-more');

	buttonElement.addEventListener('click', this.addItems);

	return buttonElement;
};

ArticleItems.prototype.getItemsLoadedCount = function(){
	var itemsLoaded = 0;
	for(var i=0;i<this.itemData.length;i++){
		if(this.itemData[i].displayed){
			itemsLoaded ++;
		}
	}

	return itemsLoaded;
};

ArticleItems.prototype.onNoResults = function(e){
	var noResultsElement = document.createElement('p');
	noResultsElement.setAttribute('class', this.options.classPrefixItem + '-message message')

	noResultsElement.appendChild(document.createTextNode(this.options.strings.noResults));

	this.resultContainer.appendChild(noResultsElement);
};

ArticleItems.prototype.createElementFromString = function(string) {
	const dummyContainer = document.createElement('div');
	dummyContainer.innerHTML = string.trim();

	return dummyContainer.firstChild;
};

ArticleItems.prototype.onError = function(errorMessage){
	//plaats voor de zekerheid de error in de console
	console.warn(errorMessage);

	//als het formElement niet bestaat kan er geen error via de DOM worden geplaatst
	if(!this.resultContainer){
		return;
	}

	//als het errorElement nog nooit is aangemaakt dan aanmaken
	if(!this.errorElement){
		var pElement = document.createElement('p');
		pElement.setAttribute('class', 'message message-error message-notification');
		this.errorElement = pElement;

		this.errorElement = this.resultContainer.parentNode.insertBefore(this.errorElement, this.resultContainer);
	}

	//verwijder huidige error content
	while(this.errorElement.firstChild){
		this.errorElement.removeChild(this.errorElement.firstChild);
	}

	this.errorElement.appendChild(document.createTextNode(errorMessage));
};

export default ArticleItems;